export default (v) => {
  return v === undefined ? null : typeof v === 'string' && v.length === 0 ? null : v
}
